import { render, staticRenderFns } from "./RBigNumber.vue?vue&type=template&id=50e0dc64&scoped=true&"
import script from "./RBigNumber.vue?vue&type=script&lang=js&"
export * from "./RBigNumber.vue?vue&type=script&lang=js&"
import style0 from "./RBigNumber.vue?vue&type=style&index=0&id=50e0dc64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e0dc64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VDivider,VIcon,VSkeletonLoader})
